module.exports = __webpack_public_path__ + "img/other-icon.bd91b752.svg";